/* CE Instant Search v1.0 — Meilisearch-powered dropdown (port of reluxe-instant-search v10.1)
   Endpoint: search.collectoredit.com | Auth: tenant token (search-only, CE inventory only) */
(function () {
  'use strict';

  const SEARCH_URL = 'https://search.collectoredit.com';
  const TENANT_TOKEN = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzZWFyY2hSdWxlcyI6eyJwcm9kdWN0cyI6eyJmaWx0ZXIiOiJzdG9yZXMgPSBjb2xsZWN0b3JlZGl0In19LCJhcGlLZXlVaWQiOiI0M2ZlY2Y1Mi02YWMwLTRkNTAtOWNjYi1lMGViZGY4YjIzNjYifQ.d_kwOHo_K8a-Ngz_EF2AHuUhIfBHWsbdbZLV9seHW6s';
  const INDEX = 'products';
  const IMG_HOST_FROM = 'api.thereluxe.com';
  const IMG_HOST_TO = 'search.collectoredit.com';

  let recentSearches = [];
  let selectedIndex = -1;
  let dropdown = null;
  let activeInput = null;
  let lastQuery = '';

  const TRENDING = ['Chanel', 'Louis Vuitton', 'Hermes', 'Gucci', 'Dior'];

  function loadLocal() {
    try {
      recentSearches = JSON.parse(localStorage.getItem('ce_recent_searches') || '[]').slice(0, 5);
    } catch (e) { recentSearches = []; }
  }

  function saveRecent(q) {
    if (!q || q.length < 2) return;
    recentSearches = [q, ...recentSearches.filter(function (s) { return s !== q; })].slice(0, 5);
    localStorage.setItem('ce_recent_searches', JSON.stringify(recentSearches));
  }

  function fixImg(url) {
    if (!url) return '';
    return url.replace(IMG_HOST_FROM, IMG_HOST_TO);
  }

  function fmtPrice(p) {
    return '$' + (p || 0).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function debounce(fn, wait) {
    let t;
    return function () {
      const args = arguments, ctx = this;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, wait);
    };
  }

  async function search(q) {
    const ctrl = new AbortController();
    const timer = setTimeout(function () { ctrl.abort(); }, 6000);
    try {
      const res = await fetch(SEARCH_URL + '/indexes/' + INDEX + '/search', {
        method: 'POST',
        signal: ctrl.signal,
        headers: {
          'Authorization': 'Bearer ' + TENANT_TOKEN,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          q: q,
          limit: 8,
          attributesToRetrieve: ['sku', 'title', 'brand', 'price', 'image', 'handle_ce']
        })
      });
      clearTimeout(timer);
      if (!res.ok) return { hits: [], estimatedTotalHits: 0 };
      return await res.json();
    } catch (e) {
      clearTimeout(timer);
      return { hits: [], estimatedTotalHits: 0 };
    }
  }

  function ensureDropdown() {
    if (dropdown) return dropdown;
    dropdown = document.createElement('div');
    dropdown.className = 'ce-instant-search__dropdown';
    dropdown.setAttribute('role', 'listbox');
    document.body.appendChild(dropdown);
    return dropdown;
  }

  // The theme opens search as a native <dialog> (top layer). Rather than float a
  // dropdown with fragile coordinates, render IN-FLOW inside the modal (right after
  // the search form) so the modal lays it out. For a non-modal input, fall back to
  // a fixed-positioned dropdown under the field.
  function mountFor(input) {
    const dd = ensureDropdown();
    const form = input.closest('form');
    const modal = input.closest('predictive-search-component, .predictive-search, .search-modal__content, dialog, .dialog-modal, .search-modal');
    if (form && modal) {
      // place right after the search form, inside its column-flow container (full width)
      if (form.nextElementSibling !== dd) form.insertAdjacentElement('afterend', dd);
      dd.classList.add('ce-is--inflow');
    } else if (modal) {
      if (dd.parentNode !== modal) modal.appendChild(dd);
      dd.classList.add('ce-is--inflow');
    } else {
      if (dd.parentNode !== document.body) document.body.appendChild(dd);
      dd.classList.remove('ce-is--inflow');
    }
  }

  function positionDropdown(input) {
    if (!dropdown) return;
    mountFor(input);
    if (dropdown.classList.contains('ce-is--inflow')) {
      dropdown.style.position = '';
      dropdown.style.top = '';
      dropdown.style.left = '';
      dropdown.style.width = '';
      return;
    }
    const r = input.getBoundingClientRect();
    dropdown.style.position = 'fixed';
    dropdown.style.top = (r.bottom + 6) + 'px';
    const width = Math.max(r.width, Math.min(480, window.innerWidth - 24));
    let left = r.left;
    if (left + width > window.innerWidth - 12) left = Math.max(12, window.innerWidth - width - 12);
    dropdown.style.left = left + 'px';
    dropdown.style.width = width + 'px';
  }

  function hideDropdown() {
    if (dropdown) dropdown.style.display = 'none';
    selectedIndex = -1;
  }

  function showSuggestions() {
    const dd = ensureDropdown();
    let html = '';
    if (recentSearches.length) {
      html += '<div class="ce-is__heading">Recent searches</div>';
      recentSearches.forEach(function (s) {
        html += '<div class="ce-is__row" data-q="' + encodeURIComponent(s) + '">' +
          '<span class="ce-is__row-icon">&#8635;</span>' + escapeHtml(s) + '</div>';
      });
    }
    html += '<div class="ce-is__heading">Trending</div>';
    TRENDING.forEach(function (s) {
      html += '<div class="ce-is__row" data-q="' + encodeURIComponent(s) + '">' +
        '<span class="ce-is__row-icon">&#8599;</span>' + escapeHtml(s) + '</div>';
    });
    dd.innerHTML = html;
    dd.style.display = 'block';
    bindRowClicks();
  }

  function escapeHtml(s) {
    const d = document.createElement('div');
    d.textContent = s;
    return d.innerHTML;
  }

  function renderResults(data, q) {
    const dd = ensureDropdown();
    if (!data.hits.length) {
      dd.innerHTML = '<div class="ce-is__empty">No results for &ldquo;' + escapeHtml(q) + '&rdquo;</div>';
      dd.style.display = 'block';
      return;
    }
    let html = '';
    data.hits.forEach(function (h, i) {
      html += '<a class="ce-is__product" data-idx="' + i + '" href="/products/' + (h.handle_ce || '') + '">' +
        '<img class="ce-is__img" loading="lazy" src="' + fixImg(h.image) + '" alt="">' +
        '<span class="ce-is__meta">' +
        '<span class="ce-is__brand">' + escapeHtml(h.brand || '') + '</span>' +
        '<span class="ce-is__title">' + escapeHtml(h.title || '') + '</span>' +
        '</span>' +
        '<span class="ce-is__price">' + fmtPrice(h.price) + '</span>' +
        '</a>';
    });
    html += '<a class="ce-is__viewall" href="/search?q=' + encodeURIComponent(q) + '">View all ' +
      data.estimatedTotalHits.toLocaleString() + ' results &rarr;</a>';
    dd.innerHTML = html;
    dd.style.display = 'block';
  }

  function bindRowClicks() {
    if (!dropdown) return;
    dropdown.querySelectorAll('.ce-is__row').forEach(function (row) {
      row.addEventListener('mousedown', function (e) {
        e.preventDefault();
        const q = decodeURIComponent(row.getAttribute('data-q'));
        saveRecent(q);
        window.location.href = '/search?q=' + encodeURIComponent(q);
      });
    });
  }

  const doSearch = debounce(async function (input) {
    const q = input.value.trim();
    lastQuery = q;
    if (q.length < 2) {
      showSuggestions();
      positionDropdown(input);
      return;
    }
    const data = await search(q);
    if (q !== lastQuery) return; // stale response
    renderResults(data, q);
    positionDropdown(input);
  }, 150);

  function items() {
    return dropdown ? Array.prototype.slice.call(dropdown.querySelectorAll('.ce-is__product, .ce-is__row, .ce-is__viewall')) : [];
  }

  function onKeydown(e) {
    if (!dropdown || dropdown.style.display === 'none') return;
    const list = items();
    if (!list.length) return;
    if (e.key === 'ArrowDown') {
      e.preventDefault();
      selectedIndex = Math.min(selectedIndex + 1, list.length - 1);
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      selectedIndex = Math.max(selectedIndex - 1, -1);
    } else if (e.key === 'Enter') {
      if (selectedIndex >= 0 && list[selectedIndex]) {
        e.preventDefault();
        const el = list[selectedIndex];
        if (el.href) { saveRecent(activeInput ? activeInput.value.trim() : ''); window.location.href = el.href; }
        else el.dispatchEvent(new MouseEvent('mousedown'));
        return;
      }
      saveRecent(activeInput ? activeInput.value.trim() : '');
      return; // let the form submit to /search?q=
    } else if (e.key === 'Escape') {
      hideDropdown();
      return;
    } else { return; }
    list.forEach(function (el, i) { el.classList.toggle('ce-is__selected', i === selectedIndex); });
  }

  function showLoading(input) {
    const dd = ensureDropdown();
    dd.innerHTML = '<div class="ce-is__empty">Searching&hellip;</div>';
    dd.style.display = 'block';
    positionDropdown(input);
  }

  function onInput(input) {
    activeInput = input;
    const q = input.value.trim();
    if (q.length >= 2) showLoading(input);   // instant feedback before the fetch returns
    else { showSuggestions(); positionDropdown(input); }
    doSearch(input);
  }

  function attach(input) {
    if (input.dataset.ceIs) return;
    input.dataset.ceIs = '1';
    input.setAttribute('autocomplete', 'off');
    // Capture phase so the theme's cmdk/predictive component can't stopPropagation our handler
    input.addEventListener('input', function () { onInput(input); }, true);
    input.addEventListener('focus', function () {
      activeInput = input;
      if (input.value.trim().length >= 2) onInput(input);
      else { showSuggestions(); positionDropdown(input); }
    }, true);
    input.addEventListener('blur', function () { setTimeout(hideDropdown, 180); });
    input.addEventListener('keydown', onKeydown, true);
  }

  function scan() {
    document.querySelectorAll('input[type="search"], input[name="q"], input.search-input').forEach(function (i) {
      if (i.name === 'country_filter' || i.closest('.country-filter, country-selector')) return;
      if (i.classList.contains('search-page-input')) return; // results-page input drives the grid, not a dropdown
      attach(i);
    });
  }

  loadLocal();
  scan();
  new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });
  window.addEventListener('resize', function () { if (activeInput && dropdown && dropdown.style.display !== 'none') positionDropdown(activeInput); });
  window.addEventListener('scroll', function () { if (activeInput && dropdown && dropdown.style.display !== 'none') positionDropdown(activeInput); }, true);
})();
